var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.toEditEvent
    ? _c(
        "w-modal",
        { attrs: { value: "", "full-height": "" } },
        [
          _c(
            "w-card",
            [
              _c(
                "w-card-title",
                [
                  _vm._v(_vm._s(_vm.$ct("create-calendar-event"))),
                  _c("w-spacer"),
                  _c(
                    "w-link",
                    {
                      attrs: { white: "" },
                      on: {
                        click: function ($event) {
                          return _vm.cancel()
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "times" } })],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-card-content",
                {
                  style: {
                    flexGrow: 1,
                    flexShrink: 1,
                    position: "relative",
                    overflow: "hidden",
                  },
                },
                [
                  _c("app-calendar-modal", {
                    style: { height: "100%" },
                    attrs: { "to-edit-event": _vm.toEditEvent },
                    on: {
                      success: function ($event) {
                        return _vm.onSuccess()
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }